// Généré par .scratch/emoji-search/gen.py depuis emojibase-data (fr, CLDR).
// Noms et mots-clés français des emojis du sélecteur. Ne pas éditer à la main.
export const EMOJI_ALIASES: Record<string, string> = {
  "😀": "visage rieur content dents grand sourire heureux joyeux rire sourire super visage visage très souriant émoticône",
  "😃": "visage souriant avec de grands yeux content dents formidable grand sourire heureux sourire super visage très souriant avec la bouche ouverte émoticône",
  "😄": "visage très souriant aux yeux rieurs content grand sourire heureux joyeux lol mdr rire sourire sourire mignon visage avec la bouche ouverte et les yeux souriants émoticône",
  "😁": "visage souriant aux yeux rieurs content dents grand sourire heureux sourire sourire de toutes ses dents super visage visage souriant avec yeux souriants yeux souriants émoticône",
  "😆": "visage souriant avec yeux plissés ahah bouche content lol mdr rire sourire visage visage souriant avec bouche ouverte et yeux fermés émoticône",
  "😅": "visage souriant avec une goutte de sueur excité froid goutte sourire sourire nerveux stressé sueur sueurs froides émoticône",
  "🤣": "se rouler par terre de rire content drôle hilare joyeux larmes lol mdr pleurer de rire rire rire aux larmes se rouler par terre se tordre de rire visage visage qui rit aux larmes émoticône",
  "😂": "visage riant aux larmes content heureux joie larmes lol mdr pleurer de joie pleurer de rire rire aux larmes sourire émoticône",
  "🙂": "visage avec un léger sourire content heureux léger sourire sourire visage souriant émoticône",
  "😊": "visage souriant avec yeux rieurs content heureux rougir satisfait sourire visage visage qui rougit visage souriant avec yeux souriants yeux émoticône œil",
  "😇": "visage souriant avec auréole bible ange angélique auréole béni heureux innocent paix sourire spirituel émoticône",
  "🥰": "visage souriant avec cœurs je t’aime adorer aimer amour béguin coeur cœurs j’adore smiley avec 3 coeurs sourire",
  "😍": "visage souriant avec yeux en forme de cœur amour amoureux cœur romantique sourire visage yeux émoticône œil",
  "🤩": "visage avec des étoiles à la place des yeux grand sourire heureux pressé surexcité tête avec étoiles visage wow yeux étoile étoiles dans les yeux",
  "😘": "visage envoyant un bisou amour baiser bise bisou et cœur bonjour bonne nuit cœur embrasser je t’aime visage qui fait une bise avec un cœur émoticône",
  "😗": "visage faisant un bisou amour baiser bise bisou embrasser je t’aime petit bisou visage qui fait une bise émoticône",
  "😚": "visage faisant un bisou avec les yeux fermés baiser bise bisou bisou les yeux fermés embrasser rougir visage qui fait une bise avec les yeux fermés visage rougissant yeux fermés émoticône",
  "😙": "visage aux yeux rieurs faisant un bisou amour baiser bise bisou embrasser gros bisou je t’aime sourire visage aux yeux souriants qui fait une bise yeux fermés émoticône",
  "🥲": "visage souriant avec une larme fier heureux larme reconnaissant smiley soulagé souriant touché ému",
  "😋": "miam bon content délicieux faim heureux langue manger savourer sourire visage souriant qui tire la langue émoticône",
  "😛": "visage qui tire la langue cool génial langue super visage émoticône",
  "😜": "visage qui tire la langue et fait un clin d’œil amusant blague clin d’œil fou langue loufoque marrant rigolo visage émoticône œil",
  "🤪": "tête de fou grand large oeil petit tête folle yeux yeux fous œil",
  "😝": "visage qui tire la langue les yeux plissés dégoûtant goût horrible langue omd on ne vit qu’une fois peu importe visage qui tire la langue et ferme les yeux yeux fermés émoticône œil",
  "🤑": "argent dans les yeux et la bouche argent bouche dollars yeux émoticône",
  "🤗": "visage qui fait un câlin câlin gentil mains visage émoticône",
  "🤭": "visage avec une main sur la bouche malin oops oups rigole secret surprise visage avec main devant la bouche",
  "🫢": "visage avec yeux ouverts et main sur la bouche choqué embarrassé gêné impressionné stupéfait surpris étonné",
  "🤫": "visage avec un doigt sur la bouche chut pas un bruit silence tête qui dit chut",
  "🤔": "visage en pleine réflexion hum méditer penser réflexion réfléchir visage émoticône",
  "🫡": "visage qui fait un salut militaire ok armée bonne chance compris oui respect salut",
  "🤐": "visage avec bouche fermeture éclair bouche bouche cousue fermeture éclair motus se taire secret visage visage avec bouche cousue émoticône",
  "🤨": "visage avec les sourcils relevés euh hein incrédule méfiant pas vrai quoi sceptique surprise tête avec sourcil levé",
  "😐": "visage neutre gêné neutre ni chaud ni froid pas drôle peu importe rester de marbre sans commentaires sans rire visage sans expression émoticône",
  "😑": "visage sans expression inexpressif mécontent neutre peu importe sans expression visage émoticône",
  "😶": "visage sans bouche muet ne rien dire neutre sans commentaires sans expression sans voix se taire secret silence sourdine émoticône",
  "🫥": "visage en pointillés disparaître déprimé introverti invisible se cacher",
  "😏": "visage avec un sourire malin arrogant charmeur malin ricaner rusé sourire sourire suffisant suspicieux séducteur visage avec un sourire suffisant émoticône",
  "😒": "visage blasé bizarre blasé fâché jaloux pas content peu importe visage visage qui s’ennuie émoticône énervé",
  "🙄": "visage roulant des yeux agacé excédé incrédulité roulement visage qui lève les yeux au ciel visage qui roule des yeux yeux émoticône",
  "😬": "visage grimaçant dents grimace gêné rien sourire visage émoticône",
  "🤥": "visage de menteur mensonge menteur pinocchio visage visage dont le nez s’allonge émoticône",
  "😌": "visage soulagé calme soulagement sérénité visage zen émoticône",
  "😔": "visage pensif abattu déçu horrible mort pensif perdu triste visage émoticône",
  "😪": "visage endormi fatigué larme pleurer sommeil triste visage émoticône",
  "🤤": "visage qui bave baver délicieux mmh visage émoticône",
  "😴": "visage somnolent bonne nuit coucher dormir endormi fatigué sieste sommeil visage zzz émoticône",
  "😷": "visage avec masque bactéries dentiste docteur germes malade masque masque chirurgical médecin rhume émoticône",
  "🤒": "visage avec thermomètre indisposé malade thermomètre visage",
  "🤕": "visage avec bandage autour de la tête aïe bandage blessure bobo pansement tête tête avec un bandage visage émoticône",
  "🤢": "visage nauséeux dégoûtant malade nausée visage visage vert qui a la nausée vomir écœuré émoticône",
  "🤮": "visage qui vomit gerbe gerber malade tête qui vomit vomi vomissure",
  "🤧": "visage qui éternue atchoum fièvre grippe malade mouchoir rhume se moucher à tes souhaits émoticône éternuement éternuer",
  "🥵": "visage rouge et chaud chaleur chaud coup de chaleur coup de chaud fièvre sue suer toute rouge transpiration trop chaud visage tout rouge",
  "🥶": "visage bleu et froid bleu froid gel gelure gelé glacial glacé glaçon visage bleu ça caille",
  "🥴": "visage éméché bouche ondulée bourré bourrée dans les vapes hébété pas clair pompette rond saoul souler tête qui tourne",
  "😵": "visage étourdi fatigué malade mort tournis visage visage avec le tournis émoticône",
  "🤯": "tête qui explose choc choqué surpris surprise tête choquée",
  "🤠": "visage avec chapeau de cowboy chapeau cowboy visage",
  "🥳": "visage festif anniversaire chapeau pointu célébration fête heureux hourra joyeux anniversaire sifflet visage de fête youpi émoticône",
  "🥸": "visage déguisé déguisement espion faux nez grimer incognito lunettes moustache postiche smiley sourcils ébouriffés",
  "😎": "visage avec lunettes de soleil cool lunettes de soleil posé tranquille",
  "🤓": "visage de geek doué futé geek idiot intelligent lunettes personne premier de la classe ringard surdoué tronche",
  "🧐": "visage avec un monocle classe collet monté fortune monocle riche tête avec monocle vieux jeu",
  "😕": "visage confus confus désolé ennuyé je ne sais pas triste visage émoticône",
  "🫤": "visage avec bouche en diagonale bof confus déçu euh frustration incertain sceptique",
  "😟": "visage inquiet anxieux inquiet préoccupé stressé surpris triste visage émoticône",
  "🙁": "visage légèrement mécontent mécontent triste visage émoticône",
  "☹️": "visage mécontent malheureux mécontent triste visage émoticône",
  "😮": "visage avec bouche ouverte bouche bée bouche ouverte choqué incroyable omd oubli surpris visage avec la bouche ouverte visage étonné émoticône épaté",
  "😯": "visage ébahi incroyable omd sans voix stupeur stupéfait surpris visage visage sans voix visage à la bouche ouverte émoticône",
  "😲": "visage stupéfait choc choqué impossible incroyable omd stupéfait visage émoticône étonné",
  "😳": "visage qui rougit chaud comment gêné impressionné incroyable incrédule quoi rouge ébahi émoticône étonné",
  "🥺": "visage implorant embarrassé excuse gros yeux pardon pitié supplication supplie s’il te plaît yeux de chiens battus",
  "🥹": "visage retenant ses larmes admiration fierté gratitude larmes de joie pleurs retenir ses larmes triste ému",
  "😦": "visage mécontent avec bouche ouverte bouche déçu effrayé ouverte peur pris au dépourvu surpris visage visage déçu avec bouche ouverte émoticône",
  "😧": "visage angoissé angoisse comment hein mécontent oubli peur quoi stressé surpris terrifié émoticône",
  "😨": "visage effrayé anxieux apeuré blême effrayé inquiet peur terrifié visage émoticône",
  "😰": "visage anxieux avec goutte de sueur aah bleu bouche bée effrayé froid mince nerveux peur bleue sueurs froides terrifié visage en sueur bouche ouverte émoticône",
  "😥": "visage triste mais soulagé déçu ouf pfiou soulagé sueur triste visage déçu mais soulagé émoticône",
  "😢": "visage qui pleure horrible larme larmes malheureux pleurer triste émoticône",
  "😭": "visage qui pleure à chaudes larmes larme larmes malheureux pleurer pleurs sangloter triste visage émoticône",
  "😱": "visage qui hurle de peur munch choqué cri effrayé omd peur surpris terreur visage",
  "😖": "visage déconcerté confus déconcerté frustré fâché irrité triste visage yeux fermés émoticône",
  "😣": "visage persévérant concentré mal de tête migraine persévérant visage émoticône",
  "😞": "visage déçu abattu affreux découragé déçu malheureux tort triste visage émoticône",
  "😓": "visage démoralisé avec goutte de sueur froide mal de tête migraine mince ouf peur sueur triste visage visage et sueurs froides émoticône",
  "😩": "visage épuisé faim fatigué mécontent non pleurer sommeil triste visage visage las échec émoticône épuisé",
  "😫": "visage fatigué contrarié fatigue mécontent triste visage émoticône",
  "🥱": "visage bâillant bâille bâiller dormir ennui fatigant fatigue sieste émoticône",
  "👋": "signe de la main au revoir bonjour bye coucou hello il y a quelqu’un ? main main qui salue salut signe à bientôt à plus tard",
  "🤚": "dos de main levée levée main",
  "🖐️": "main levée doigts écartés doigts main paume stop",
  "✋": "main levée feuille main paume de la main stop tope là",
  "🖖": "salut vulcain spock star trek doigts main vulcain",
  "🫱": "main vers la droite droite serrer la main tenir la main vers la droite",
  "🫲": "main vers la gauche gauche serrer la main tenir la main vers la gauche",
  "🫳": "main paume vers le bas chasser choisir faire partir laisser tomber ouste rejeter",
  "🫴": "main paume vers le haut appeler de la main attirer faire venir offre",
  "👌": "ok compris d’accord geste main nickel parfait super tout va bien",
  "🤌": "bout des doigts joints agacement argumentation doigts geste interrogation main parler avec les mains patience silence !",
  "🤏": "pouce et index rapprochés petit petite petite quantité petite somme peu un peu à deux doigts",
  "✌️": "v de la victoire ciseaux doigts main paix et amour peace and love victoire",
  "🤞": "doigts croisés bonne chance chance croisés doigts main",
  "🫰": "main avec index et pouce croisés amour argent cher claquer des doigts cœur",
  "🤟": "signe je t’aime ily amour geste pour je t’aime je t’aime main trois doigts",
  "🤘": "cornes avec les doigts cornes cornes du diable doigts main rock rock’n roll yeah",
  "🤙": "signe appel téléphonique avec les doigts appel main signe téléphone",
  "👈": "main avec index pointant à gauche doigt gauche index index pointé vers la gauche main",
  "👉": "main avec index pointant à droite doigt droite index index pointé vers la droite main",
  "👆": "main avec index pointant vers le haut doigt haut index index vers le haut main montrer",
  "🖕": "doigt d’honneur doigt main majeur",
  "👇": "main avec index pointant vers le bas bas doigt index index vers le bas main montrer",
  "☝️": "index pointant vers le haut doigt haut index index pointé vers le haut main moi",
  "🫵": "index pointant vers l’utilisateur pointer toi",
  "👍": "pouce vers le haut +1 ok bien compris d’accord génial haut oui super",
  "👎": "pouce vers le bas bas main mauvais non nul pouce pouce baissé",
  "✊": "poing levé main pierre poing poing serré solidarité",
  "👊": "poing de face absolument battre boum correct coup de poing d’accord main mon pote poing serrer",
  "🤛": "poing à gauche fistbump gauche main poing",
  "🤜": "poing à droite droite main poing",
  "👏": "applaudissements bien joué bon travail bravo formidable félicitations geste mains mains qui applaudissent super",
  "🙌": "mains levées air geste hourra mains mains en l’air youpi",
  "🫶": "mains qui forment un cœur amour cœur",
  "👐": "mains ouvertes main mains écartées ouvert",
  "🤲": "paume contre paume doigts vers le haut espérer mains paumes des mains ensemble prier prière",
  "🤝": "poignée de main d’accord main mains marché conclu poignée présentation rencontre serrer la main",
  "🙏": "mains en prière demander félicitations mains mains l’une contre l’autre merci prier prière salut se taper dans la main s’il te plaît s’il vous plaît tope là",
  "✍️": "main qui écrit main écrire",
  "💪": "biceps contracté bd bande dessinée biceps bodybuilding contracté corps culturisme entraînement exercice force haltérophilie muscle muscles soulever",
  "👶": "bébé enceinte enfant nouveau-né petit émoticône",
  "👧": "fille couettes enfant grands yeux jeune nattes personne petite fille tresses vierge visage zodiaque émoticône",
  "🧒": "enfant genre neutre jeune non-genré",
  "👦": "garçon enfant jeune personne émoticône",
  "👩": "femme blonde coupe de cheveux personne",
  "🧑": "adulte genre neutre non-genré",
  "👨": "homme ami garçon personne petit ami pote",
  "👩‍🦱": "femme : cheveux bouclés blonde cheveux bouclés coupe de cheveux femme personne",
  "🧑‍🦱": "adulte : cheveux bouclés adulte cheveux bouclés genre neutre non-genré",
  "👨‍🦱": "homme : cheveux bouclés ami cheveux bouclés garçon homme personne petit ami pote",
  "👩‍🦰": "femme : cheveux roux blonde cheveux roux coupe de cheveux femme personne",
  "🧑‍🦰": "adulte : cheveux roux adulte cheveux roux genre neutre non-genré",
  "👨‍🦰": "homme : cheveux roux ami cheveux roux garçon homme personne petit ami pote",
  "👱‍♀️": "femme blonde blonde cheveux femme personne",
  "👱": "personne blonde blond cheveux garçon homme humain tête visage",
  "👱‍♂️": "homme blond blond cheveux",
  "👩‍🦳": "femme : cheveux blancs blonde cheveux blancs coupe de cheveux femme personne",
  "🧑‍🦳": "adulte : cheveux blancs adulte cheveux blancs genre neutre non-genré",
  "👨‍🦳": "homme : cheveux blancs ami cheveux blancs garçon homme personne petit ami pote",
  "👩‍🦲": "femme : chauve blonde chauve coupe de cheveux femme personne",
  "🧑‍🦲": "adulte : chauve adulte chauve genre neutre non-genré",
  "👨‍🦲": "homme : chauve ami chauve garçon homme personne petit ami pote",
  "🧔‍♀️": "femme barbue barbe",
  "🧔": "personne barbue barbe barbu personne avec une barbe",
  "🧔‍♂️": "homme barbu barbe",
  "👵": "femme âgée blonde dame femme grand-mère mamie personne sage âgée émoticône",
  "🧓": "personne âgée adulte genre neutre non-genré âgé",
  "👴": "homme âgé chauve grand-père homme papi personne personne âgée sage vieux monsieur âgé émoticône",
  "👲": "homme avec casquette chinoise casquette mao chapeau homme",
  "👳‍♀️": "femme en turban femme femme avec turban turban",
  "🧕": "femme avec foulard bandana femme avec un voile foulard hijab mantilla tichel voile",
  "👮‍♀️": "policière autorité femme flic loi métier officier personne police tenue uniforme",
  "👮": "officier de police autorité flic homme loi métier officier personne police policier tenue uniforme",
  "👷‍♀️": "ouvrière du bâtiment bâtiment casque casque de chantier chantier femme métier ouvrier du bâtiment femme ouvrière",
  "👷": "personnel du bâtiment btp bâtiment casque chantier construction homme métier ouvrier personne réparer",
  "💂‍♀️": "garde femme buckingham palace londres casque femme garde métier",
  "💂": "garde buckingham palace londres casque garde homme",
  "🕵️‍♀️": "détective femme détective enquêteuse enquêtrice espionne femme",
  "🕵️": "détective enquêteur espion homme",
  "👩‍⚕️": "professionnelle de la santé docteur docteure femme femme profession médicale infirmière médecin métier profession médicale santé",
  "🐶": "tête de chien animal animal domestique chien chiot visage",
  "🐱": "tête de chat animal chat chaton miaou minou",
  "🐭": "tête de souris animal souris visage",
  "🐹": "hamster animal animal domestique tête tête de hamster visage",
  "🐰": "tête de lapin animal animal domestique dents lapin",
  "🦊": "renard animal nature tête visage",
  "🐻": "ours animal miel nounours ours brun teddy tête visage",
  "🐼": "panda animal tête tête de panda visage",
  "🐻‍❄️": "ours polaire arctique blanc ours",
  "🐨": "koala australie animal",
  "🐯": "tête de tigre animal félin prédateur tigre visage",
  "🦁": "tête de lion animal astrologie crinière fort horoscope lion roi rugissement safari savane visage zodiaque",
  "🐮": "tête de vache animal lait meuh vache visage",
  "🐷": "tête de cochon animal cochon ferme porc visage",
  "🐸": "grenouille animal crapaud tête tête de grenouille",
  "🐵": "tête de singe georges le petit curieux animal singe sourire visage",
  "🙈": "singe ne rien voir animal caché effrayé embarras geste gêne interdit ne pas voir non omd oubli peur rien vu rien entendu secret singe visage voir yeux",
  "🙉": "singe ne rien entendre animal geste interdit ne pas entendre non oreilles rien vu rien entendu secret singe sourd visage écouter",
  "🙊": "singe ne rien dire animal bouche cousue chut geste interdit motus muet non parler se taire secret silence singe visage",
  "🐒": "singe animal primate",
  "🐔": "poule animal coq ferme oiseau poulet volaille",
  "🐧": "pingouin antarctique animal banquise manchot oiseau",
  "🐦": "oiseau animal ornithologie",
  "🐤": "poussin animal oiseau tête de poussin",
  "🐣": "poussin qui éclôt animal bébé naissance naître nouveau-né oiseau poussin éclosion œuf",
  "🐥": "poussin de face animal bébé nouveau-né oiseau poussin",
  "🦆": "canard animal coin-coin oiseau",
  "🦅": "aigle animal oiseau rapace",
  "🦉": "chouette animal hibou oiseau sage",
  "🦇": "chauve-souris animal vampire",
  "🐺": "loup animal louve tête tête de loup",
  "🐗": "sanglier game of thrones animal",
  "🐴": "tête de cheval animal cheval dressage ferme jument équitation",
  "🦄": "licorne animal licrone tête tête de licorne",
  "🐝": "abeille animal bourdon guêpe insecte miel nature printemps",
  "🪱": "lombric animal annélide insecte parasite ver ver de terre",
  "🐛": "chenille animal insecte jardin",
  "🦋": "papillon animal insecte mignon printemps",
  "🐌": "escargot animal jardin lentement nature",
  "🐞": "coccinelle animal bête insecte jardin nature",
  "🌸": "fleur de cerisier bourgeon fleur plante printemps",
  "💮": "fleur blanche fleur",
  "🏵️": "rosette plante",
  "🌹": "rose saint-valentin amour beauté fleur plante rouge",
  "🥀": "fleur fanée fanée fleur mort rose",
  "🌺": "hibiscus fleur plante",
  "🌻": "tournesol champs fleur plante soleil",
  "🌼": "bourgeon bouton d’or dent-de-lion fleur pissenlit plante printemps",
  "🌷": "tulipe bourgeon fleur plante printemps",
  "🌱": "jeune pousse germe jeune plant plante plantule pousser printemps semis",
  "🍎": "pomme rouge fruit nourriture pomme",
  "🍐": "poire fruit nourriture",
  "🍊": "mandarine agrume clémentine fruit nourriture orange vitamine c",
  "🍋": "citron acide agrume fruit nourriture zeste",
  "🍌": "banane fruit nourriture potassium",
  "🍉": "pastèque fruit",
  "🍇": "raisin fruit nourriture",
  "🍓": "fraise fruit nourriture",
  "🫐": "myrtilles airelles baies bleu bleuets fruit nourriture violet",
  "🍈": "melon fruit",
  "🍒": "cerises cerise fruit nourriture",
  "🍑": "pêche fruit nourriture",
  "🥭": "mangue fruit nourriture tropical tropique",
  "🍍": "ananas fruit nourriture tropical",
  "🥥": "noix de coco coco fruit nourriture palmier piña colada",
  "🥝": "kiwi fruit nourriture",
  "🍅": "tomate fruit légume nourriture plante",
  "🍆": "aubergine légume nourriture",
  "🥑": "avocat fruit nourriture",
  "🥦": "brocoli broccoli chou chou sauvage légume",
  "🍕": "pizza fromage nourriture part pepperoni tranche",
  "🍔": "hamburger burger cheeseburger fast food nourriture",
  "🍟": "frites fast food potatoes potatœs",
  "🌭": "hot dog nourriture saucisse saucisse de francfort",
  "🍿": "pop-corn cinéma nourriture",
  "🧂": "sel condiment salière salé saveur",
  "🥓": "lard bacon nourriture porc viande",
  "🥚": "œuf nourriture",
  "🍳": "œuf au plat cuisine friture nourriture petit-déjeuner poêle poêle à frire se faire cuire un œuf œuf",
  "🧇": "gaufre brunch gourmandise goûter moule petit déjeuner petit-déjeuner pâtisserie",
  "🥞": "pancakes crêpe goûter nourriture pancake petit-déjeuner",
  "🧈": "beurre gras produit laitier",
  "🍞": "pain miche nourriture pain de mie",
  "🥐": "croissant nourriture pain petit-déjeuner viennoiserie",
  "🥖": "baguette nourriture pain",
  "🥨": "bretzel nourriture torsade",
  "🧀": "part de fromage fromage nourriture",
  "🥗": "salade verte nourriture salade verte",
  "🥙": "kebab falafel nourriture pain pita",
  "🌮": "taco mexicain nourriture",
  "☕": "boisson chaude boisson café caféine matin thé",
  "🍵": "tasse boisson tasse de thé sans anse thé",
  "🧃": "briquette de jus boisson carton jus jus de fruits paille",
  "🥤": "gobelet avec paille boisson eau jus de fruit jus de fruits soda verre avec une paille",
  "🧋": "thé aux perles boba boisson bubble tea bulle lait paille perle thé aux bulles thé froid zenzou",
  "🍶": "saké boisson bouteille bouteille et verre restaurant verre",
  "🍺": "chope alcool bar bière boisson chope de bière oktoberfest picoler pinte santé",
  "🍻": "chopes de bière alcool bière boisson santé tchin trinquer",
  "🥂": "trinquer alcool champagne célébrer fêter santé tchin verre verres",
  "🍷": "verre de vin alcool bar boisson club restaurant verre verre à vin vin",
  "⚽": "ballon de football balle ballon football sport",
  "🏀": "basket ballon basket-ball panier sport",
  "🏈": "football américain super bowl ballon sport",
  "⚾": "baseball balle balle de baseball sport",
  "🥎": "softball balle gant sports",
  "🎾": "tennis balle balle de tennis sport",
  "🏐": "volley-ball ballon jeu match sport volley",
  "🏉": "rugby ballon sport",
  "🥏": "disque volant discoplane disque disque-volant frisbee sport ultimate ultime-passe",
  "🎱": "boule de billard 8 billard boule magique huit jeu pool",
  "🪀": "yoyo descendre jouet monter osciller",
  "🏓": "ping-pong balle jeu partie raquette sport tennis de table",
  "🏸": "badminton jeu match raquette sport volant",
  "🏒": "hockey sur glace crosse hockey palet sport",
  "🏑": "hockey sur gazon balle crosse hockey sport",
  "🥍": "crosse balle but lacrosse raquette sport",
  "🏏": "cricket balle balle de cricket batte jeu match sport",
  "🪃": "boomerang aborigène australie jeu outil retour répercussion",
  "🥅": "cage but filet sport",
  "⛳": "drapeau de golf golf sport trou",
  "🎯": "dans le mille cible fléchettes jeu",
  "🏹": "arc et flèche sagittaire arc archer astrologie flèche horoscope sport tir à l’arc zodiaque",
  "🎣": "pêche à la ligne canne à pêche pêche sport",
  "🤿": "masque de plongée apnée masque masque et tuba plonger plongée snorkeling tuba",
  "🥊": "gant de boxe boxe gant sport",
  "🥋": "tenue d’arts martiaux arts martiaux judo karaté kimono sport taekwondo tenue",
  "🎽": "maillot de course athlétisme course à pied jogging running sport tee-shirt de course",
  "🛹": "planche à roulettes glisse longboard roulettes skate skateboard",
  "🛼": "patin à roulettes derby roller roulette roulettes sport",
  "🛷": "luge glisser neige traîneau",
  "⛸️": "patin à glace glace patin patiner patinoire sport",
  "🥌": "pierre de curling curling granit jeu match partie pierre sport",
  "🎿": "ski neige sport",
  "⛷️": "skieur neige ski sport",
  "🏂": "snowboardeur homme neige ski snowboard sport",
  "🪂": "parachute chute libre parachute ascensionnel parapente sensations fortes",
  "🏋️": "haltérophile bodybuilding entraînement force haltérophilie homme lever des poids muscles personne poids sport",
  "🤼": "personnes faisant de la lutte bataille lutte lutteur lutteurs personnes sport",
  "🤸": "personne faisant la roue agilité athlète faire la roue femme faisant la roue gymnaste gymnastique personne roue sport",
  "🤺": "escrimeur escrime escrimeuse personne sport épée",
  "🎮": "jeu vidéo joystick manette playstation xbox",
  "🕹️": "manette de jeu jeu jeu vidéo joystick",
  "🎲": "dés dé hasard jeu",
  "🧩": "pièce de puzzle assemblage indice interloqué pièce manquante puzzle énigme",
  "♟️": "pion d’échec duper sacrifiable échec",
  "🎭": "spectacle vivant acteur actrice art masque spectacle théâtre",
  "🎨": "palette de peinture art artiste couleurs musée de peinture peindre peintre peinture",
  "🎬": "clap action film ça tourne",
  "🎤": "micro chanter karaoke karaoké microphone musique",
  "🎧": "casque musique son écouteur écouteurs",
  "⌚": "montre heure",
  "📱": "téléphone portable communication smartphone téléphone",
  "📲": "appel entrant appel communication recevoir un appel smartphone téléphone portable avec une flèche",
  "💻": "ordinateur portable bureau ordinateur travail",
  "⌨️": "clavier informatique ordinateur",
  "🖥️": "ordinateur de bureau moniteur ordinateur",
  "🖨️": "imprimante imprimer ordinateur",
  "🖱️": "souris d’ordinateur informatique souris",
  "🖲️": "boule de commande informatique ordinateur souris à boule trackball",
  "💽": "disque d’ordinateur disque minidisc",
  "💾": "disquette disque informatique ordinateur",
  "💿": "cd dvd blu-ray disque",
  "📀": "dvd cd blu-ray disque",
  "📼": "cassette vidéo magnétoscope vhs vidéocassette vintage",
  "📷": "appareil photo photo selfie vidéo",
  "📸": "appareil photo avec flash appareil photo flash",
  "📹": "caméscope caméra filmer vidéo",
  "🎥": "caméra cinéma film filmer réalisateur réalisatrice vidéo",
  "📽️": "projecteur cinématographique cinéma film projecteur vidéo",
  "🎞️": "pellicule bande cinéma film",
  "📞": "combiné téléphonique communication téléphone",
  "☎️": "téléphone téléphone rouge",
  "📟": "bipeur bip communication pager",
  "📠": "fax communication télécopieur",
  "📺": "téléviseur tv petit écran télé télévision",
  "📻": "radio actualités communication loisirs musique vidéo",
  "🎙️": "micro de studio chant enregistrement micro microphone musique studio",
  "🎚️": "curseur de niveau curseur musique niveau",
  "🎛️": "boutons de réglage boutons boutons de commande boutons de contrôle commande musique réglages",
  "🧭": "boussole compas direction magnétique navigation orientation",
  "⏱️": "chronomètre heure temps",
  "⏲️": "horloge heure minuteur temps",
  "⏰": "réveil alarme attendre dring heure matin retard sonnerie",
  "🕰️": "pendule horloge horloge posée",
  "💡": "ampoule bd allumer bande dessinée dessin idée lampe lumière",
  "🔦": "torche lampe torche lampe électrique lumière outil",
  "🏮": "lampion rouge japonais lanterne lumière restaurant rouge",
  "🪔": "diya diwali fête inde huile lampe lampe inde lampe à beurre ārtī",
  "📔": "carnet avec couverture cahier carnet livre école écrire",
  "📕": "livre fermé apprendre enseignement lire littérature livre livre rouge manuel scolaire savoir école",
  "💰": "sac plein d’argent argent avare banque dollar parier payer sac sac d’argent",
  "💳": "carte bancaire argent bancaire banque carte carte de crédit payer",
  "💎": "pierre précieuse argent bijou diamant fiançailles joyau mariage romantique",
  "⚖️": "balance à poids astrologie balance horoscope justice poids zodiaque",
  "🪜": "échelle ascension barreau escabeau grimper monter échelon",
  "🧰": "boîte à outils caisse à outils coffre mécanique mécano outil outils",
  "🪛": "tournevis outil outillage vis",
  "🔧": "clé à molette clé outil travaux",
  "🔨": "marteau outil réparer travaux",
  "⚒️": "marteau et pioche burin marteau marteau et burin outil outils pioche",
  "❤️": "cœur rouge amour cœur sentiment",
  "🧡": "cœur orange coeur orange orange",
  "💛": "cœur jaune amour cœur sentiment",
  "💚": "cœur vert amour cœur sentiment vert",
  "💙": "cœur bleu amour cœur sentiment",
  "💜": "cœur violet amour cœur sentiment violet",
  "🖤": "cœur noir cœur noir",
  "🤍": "cœur blanc blanc cœur",
  "🤎": "cœur marron brun cœur marron",
  "💔": "cœur brisé amour cœur malheureux sentiment séparé triste",
  "❤️‍🔥": "cœur enflammé amour désir feu passion",
  "❤️‍🩹": "cœur avec bandages réconforter réparer soigner",
  "💕": "deux cœurs amour anniversaire cœurs deux cœurs roses petits cœurs rendez-vous sentiment",
  "💞": "cœurs qui tournent amour anniversaire cœurs deux cœurs sentiment tourbillon",
  "💓": "cœur battant amour cardio cœur cœur qui bat pulsations sentiment",
  "💗": "cœur grandissant amour cœur cœur battant cœur qui bat pulsations sentiment",
  "💖": "cœur étincelant amour cœur sentiment étincelles",
  "💘": "cœur et flèche cupidon amour coeur transpercé cœur flèche sentiment",
  "💝": "cœur avec ruban saint-valentin amour anniversaire cœur ruban sentiment",
  "💟": "décoration avec cœur amour cœur cœur blanc cœur décoré cœur violet sentiment",
  "✅": "bouton coché ok carré coche coche blanche marque oui sélection terminé voilà ✓",
  "❌": "croix annuler croix rouge multiplication multiplier x ×",
  "⭕": "cercle rouge 0 o anneau cercle gros cercle rouge",
  "❗": "point d’exclamation rouge ! exclamation point d’exclamation ponctuation",
  "❓": "point d’interrogation rouge ? interrogation point d’interrogation ponctuation question",
  "❕": "point d’exclamation blanc ! exclamation ponctuation surprise",
  "❔": "point d’interrogation blanc ? interrogation ponctuation question",
  "💯": "cent points 100 cent score",
  "🔥": "feu allumer brûler chaud flamme fournaise incendie",
  "✨": "étincelles * magie nuit nuit étoilée scintiller étoile étoiles",
  "⭐": "étoile astronomie nuit",
  "🌟": "étoile brillante nuit nuit étoilée succès éclat étincelant étincelle étoile",
  "💫": "étourdissement bd bande dessinée tournis voir des étoiles étincelles étoile étoile filante",
  "💥": "explosion bd bande dessinée bombe boum collision détonation étincelles",
  "💢": "symbole de colère bd bande dessinée colère dessin furieux",
  "💦": "gouttes de sueur bd bande dessinée eau effort entraînement gouttes sueur éclabousser éclaboussures",
  "💨": "décamper bd bande dessinée déguerpir détaler filer fumée nuage partir en courant pet vent vite",
  "🕳️": "trou",
  "💬": "bulle de parole bd sms bande dessinée bulle dialogue message écrire",
  "👁️‍🗨️": "œil dans une bulle de bd bd bande dessinée bulle de bd témoin voir œil",
  "🗨️": "bulle de parole gauche bulle bulle à gauche dialogue gauche",
  "🗯️": "bulle colère droite bd bande dessinée bulle colère crier droite hurler",
  "💭": "bulle de pensée bd bande dessinée bulle idée imaginer inventer invention penser pensée rêve rêver",
  "💤": "endormi bd bande dessinée bonne nuit dormir fatigué ronfler zzz",
  "🎵": "note de musique musique note",
  "🎶": "notes de musique musique note notes partition",
  "🔔": "cloche clochette sonner",
  "🔕": "alarme désactivée barrée cloche silence",
  "📣": "porte-voix encourager hourra manifestation mégaphone",
  "📢": "haut-parleur communication fort message mégaphone son",
  "🏳️": "drapeau blanc drapeau drapeau qui flotte au vent",
  "🏴": "drapeau noir drapeau drapeau qui flotte au vent",
  "🏁": "drapeau à damier course automobile damier drapeau formule 1 ligne d’arrivée sport automobile vainqueur",
  "🚩": "drapeau triangulaire drapeau drapeau rouge fanion golf",
  "🏳️‍🌈": "drapeau arc-en-ciel arc-en-ciel drapeau lgbt",
  "🏳️‍⚧️": "drapeau transgenre blanc bleu clair rose transgenre",
  "🇫🇷": "drapeau : france fr drapeau",
  "🇺🇸": "drapeau : états-unis us drapeau",
  "🇬🇧": "drapeau : royaume-uni gb drapeau",
  "🇩🇪": "drapeau : allemagne de drapeau",
  "🇪🇸": "drapeau : espagne es drapeau",
  "🇮🇹": "drapeau : italie it drapeau",
  "🇵🇹": "drapeau : portugal pt drapeau",
  "🇧🇪": "drapeau : belgique be drapeau",
  "🇨🇭": "drapeau : suisse ch drapeau",
  "🇨🇦": "drapeau : canada ca drapeau",
  "🇯🇵": "drapeau : japon jp drapeau",
  "🇨🇳": "drapeau : chine cn drapeau",
  "🇰🇷": "drapeau : corée du sud kr drapeau",
  "🇧🇷": "drapeau : brésil br drapeau",
};
